export default __webpack_public_path__ + "static/media/pic_succsess_enroll.1c7aa03d.png";